import { withSuspense } from "@keepeek/refront-components";
import { Box, CircularProgress, Typography } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { KIcon } from "../../../../components/common/KIcon";
import { selectedBasketsWidgetState } from "../atoms";
import { SelectBasketsState, useBasketsWidget } from "../hooks";

const BasketsWidgetActionsSelect = function ({
  widgetId,
  queryFilter,
  sizeParam,
  pageParam,
}: {
  widgetId: string;
  queryFilter: string;
  sizeParam?: number;
  pageParam?: number;
}) {
  const { toggleSelect, selectedState } = useBasketsWidget({
    widgetId,
    queryFilter,
    sizeParam,
    pageParam,
  });
  const selectedBaskets = useRecoilValue(selectedBasketsWidgetState(widgetId));
  const { t } = useTranslation();

  const check = () => {
    switch (selectedState) {
      case SelectBasketsState.SELECTED:
        return (
          <KIcon
            fontSize="small"
            className={"fa-solid fa-square-check fa-lg"}
            testId="selectAllButton-selected"
          />
        );
      case SelectBasketsState.PARTIAL:
        return (
          <KIcon
            fontSize="small"
            className={"fa-solid fa-square-minus fa-lg"}
            testId="selectAllButton-partial"
          />
        );
      default:
        return (
          <KIcon
            fontSize="small"
            className={"fa-regular fa-square fa-lg"}
            testId="selectAllButton-unselected"
          />
        );
    }
  };

  return (
    <Box
      component="button"
      sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      onClick={toggleSelect}
      className={clsx("BasketsWidget-actionsSelect")}
    >
      {check()}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginLeft: (theme) => theme.spacing(0.5),
        }}
      >
        {selectedBaskets.length !== 0 && (
          <Typography variant="subtitle1" fontWeight="bold">
            {t("common:basketsWidget.actions.select.basket.label", {
              count: selectedBaskets.length ?? 0,
            })}
          </Typography>
        )}
        {!selectedBaskets ||
          (selectedBaskets.length == 0 && (
            <Typography variant="button" sx={{ textAlign: "left", fontSize: "80%" }}>
              {t("common:basketsWidget.actions.select.basket.currentPage.label")}
            </Typography>
          ))}
      </Box>
    </Box>
  );
};

const BasketsWidgetActionsSelectLoading = function () {
  const { t } = useTranslation();
  return (
    <Box
      component="button"
      sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      disabled
    >
      <CircularProgress size={20} />
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Typography variant="button" sx={{ maxWidth: "20ch", textAlign: "left", fontSize: "80%" }}>
          {t("common:basketsWidget.actions.select.basket.currentPage.label")}
        </Typography>
      </Box>
    </Box>
  );
};

export default withSuspense(BasketsWidgetActionsSelect, {
  LoadingComponent: BasketsWidgetActionsSelectLoading,
});
